/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LocalTime } from './LocalTime';
import {
    LocalTimeFromJSON,
    LocalTimeFromJSONTyped,
    LocalTimeToJSON,
} from './LocalTime';
import type { PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore } from './PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore';
import {
    PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBeforeFromJSON,
    PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBeforeFromJSONTyped,
    PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBeforeToJSON,
} from './PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore';

/**
 * 
 * @export
 * @interface PartnerStationDtoTimeZoneRulesTransitionRulesInner
 */
export interface PartnerStationDtoTimeZoneRulesTransitionRulesInner {
    /**
     * 
     * @type {string}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionRulesInner
     */
    month?: PartnerStationDtoTimeZoneRulesTransitionRulesInnerMonthEnum;
    /**
     * 
     * @type {string}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionRulesInner
     */
    timeDefinition?: PartnerStationDtoTimeZoneRulesTransitionRulesInnerTimeDefinitionEnum;
    /**
     * 
     * @type {PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionRulesInner
     */
    standardOffset?: PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore;
    /**
     * 
     * @type {PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionRulesInner
     */
    offsetBefore?: PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore;
    /**
     * 
     * @type {PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionRulesInner
     */
    offsetAfter?: PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBefore;
    /**
     * 
     * @type {string}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionRulesInner
     */
    dayOfWeek?: PartnerStationDtoTimeZoneRulesTransitionRulesInnerDayOfWeekEnum;
    /**
     * 
     * @type {number}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionRulesInner
     */
    dayOfMonthIndicator?: number;
    /**
     * 
     * @type {LocalTime}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionRulesInner
     */
    localTime?: LocalTime;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerStationDtoTimeZoneRulesTransitionRulesInner
     */
    midnightEndOfDay?: boolean;
}


/**
 * @export
 */
export const PartnerStationDtoTimeZoneRulesTransitionRulesInnerMonthEnum = {
    JANUARY: 'JANUARY',
    FEBRUARY: 'FEBRUARY',
    MARCH: 'MARCH',
    APRIL: 'APRIL',
    MAY: 'MAY',
    JUNE: 'JUNE',
    JULY: 'JULY',
    AUGUST: 'AUGUST',
    SEPTEMBER: 'SEPTEMBER',
    OCTOBER: 'OCTOBER',
    NOVEMBER: 'NOVEMBER',
    DECEMBER: 'DECEMBER'
} as const;
export type PartnerStationDtoTimeZoneRulesTransitionRulesInnerMonthEnum = typeof PartnerStationDtoTimeZoneRulesTransitionRulesInnerMonthEnum[keyof typeof PartnerStationDtoTimeZoneRulesTransitionRulesInnerMonthEnum];

/**
 * @export
 */
export const PartnerStationDtoTimeZoneRulesTransitionRulesInnerTimeDefinitionEnum = {
    UTC: 'UTC',
    WALL: 'WALL',
    STANDARD: 'STANDARD'
} as const;
export type PartnerStationDtoTimeZoneRulesTransitionRulesInnerTimeDefinitionEnum = typeof PartnerStationDtoTimeZoneRulesTransitionRulesInnerTimeDefinitionEnum[keyof typeof PartnerStationDtoTimeZoneRulesTransitionRulesInnerTimeDefinitionEnum];

/**
 * @export
 */
export const PartnerStationDtoTimeZoneRulesTransitionRulesInnerDayOfWeekEnum = {
    MONDAY: 'MONDAY',
    TUESDAY: 'TUESDAY',
    WEDNESDAY: 'WEDNESDAY',
    THURSDAY: 'THURSDAY',
    FRIDAY: 'FRIDAY',
    SATURDAY: 'SATURDAY',
    SUNDAY: 'SUNDAY'
} as const;
export type PartnerStationDtoTimeZoneRulesTransitionRulesInnerDayOfWeekEnum = typeof PartnerStationDtoTimeZoneRulesTransitionRulesInnerDayOfWeekEnum[keyof typeof PartnerStationDtoTimeZoneRulesTransitionRulesInnerDayOfWeekEnum];


/**
 * Check if a given object implements the PartnerStationDtoTimeZoneRulesTransitionRulesInner interface.
 */
export function instanceOfPartnerStationDtoTimeZoneRulesTransitionRulesInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PartnerStationDtoTimeZoneRulesTransitionRulesInnerFromJSON(json: any): PartnerStationDtoTimeZoneRulesTransitionRulesInner {
    return PartnerStationDtoTimeZoneRulesTransitionRulesInnerFromJSONTyped(json, false);
}

export function PartnerStationDtoTimeZoneRulesTransitionRulesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerStationDtoTimeZoneRulesTransitionRulesInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'month': !exists(json, 'month') ? undefined : json['month'],
        'timeDefinition': !exists(json, 'timeDefinition') ? undefined : json['timeDefinition'],
        'standardOffset': !exists(json, 'standardOffset') ? undefined : PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBeforeFromJSON(json['standardOffset']),
        'offsetBefore': !exists(json, 'offsetBefore') ? undefined : PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBeforeFromJSON(json['offsetBefore']),
        'offsetAfter': !exists(json, 'offsetAfter') ? undefined : PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBeforeFromJSON(json['offsetAfter']),
        'dayOfWeek': !exists(json, 'dayOfWeek') ? undefined : json['dayOfWeek'],
        'dayOfMonthIndicator': !exists(json, 'dayOfMonthIndicator') ? undefined : json['dayOfMonthIndicator'],
        'localTime': !exists(json, 'localTime') ? undefined : LocalTimeFromJSON(json['localTime']),
        'midnightEndOfDay': !exists(json, 'midnightEndOfDay') ? undefined : json['midnightEndOfDay'],
    };
}

export function PartnerStationDtoTimeZoneRulesTransitionRulesInnerToJSON(value?: PartnerStationDtoTimeZoneRulesTransitionRulesInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'month': value.month,
        'timeDefinition': value.timeDefinition,
        'standardOffset': PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBeforeToJSON(value.standardOffset),
        'offsetBefore': PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBeforeToJSON(value.offsetBefore),
        'offsetAfter': PartnerStationDtoTimeZoneRulesTransitionsInnerOffsetBeforeToJSON(value.offsetAfter),
        'dayOfWeek': value.dayOfWeek,
        'dayOfMonthIndicator': value.dayOfMonthIndicator,
        'localTime': LocalTimeToJSON(value.localTime),
        'midnightEndOfDay': value.midnightEndOfDay,
    };
}

